import React, {useRef, useEffect, useCallback, useState } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setFilters, resetFilters} from 'reducers/filtersVehiclesSlice';
import { ENDPOINT, LIMIT_PAGE } from "constants/variables";
import { resetPagination } from 'reducers/paginationVehiclesSlice';
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';  
import MenuItem  from "@mui/material/MenuItem"; 
import SearchIcon from '@mui/icons-material/Search';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import TextField from '@mui/material/TextField'; 
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import { useTranslation } from "react-i18next"   
import { NumericFormat } from 'components/utils/NumericFormat';
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import TableSortingVehicles from "pages/vehicles/SortingTablesVehicles";  
import VehiclesSearchDrivers from "pages/vehicles/VehicleSearchDrivers";
import VehiclesSearchStores from "pages/vehicles/StoresSearchStores";
import PropTypes from 'prop-types'; 

const initialFilters= {
  "idFrom":"",
  "idTo":"",
  "licenseplateFrom":"",
  "licenseplateTo":"",
  "taraFrom":"",
  "taraTo":"",
  "pmaFrom":"",
  "pmaTo":"",
  "checkpma":true,
  "notcheckpma":true,
  "defaultdriverFrom":"",
	"defaultdriverTo":"",
  "vehicleStoreFrom":"",
  "vehicleStoreTo":"",
  "enabled":true,
  "notenabled":true 
}; 

const initialState = [{
  "id" : "",
  "licenseplate" : "",
  "defaultvehicle" : false,
  "tara" : 0,
  "pma" : 0,
  "checkpma" : true, 
  "enabled" : true,
  "vehiclestore_store_id" : 0,
  "vehiclestore_store_tradename" : "",
  "vehiclestore_person_id" : 0,
  "vehiclestore_person_numberdocument" : "",
  "vehiclestore_person_fullname" : "",
 }];

const initialDocumentIdToSelect = [{
  "id": "",
  "documentid": "",
  "tradename": ""
}];

const initialStoresToSelect = [{
  "id": "",
  "documentid": "",
  "tradename": ""
}];

const initialVehicleToSelect = [{
  "id": "",
  "vehiclestore_licenseplate": "" 
}];

const headCells = [
  {
    id: 'vehiclestore_tradename',
    numeric: false,
    disablePadding: false,
    label: 'Text_Vehicle_STORE',
    canOrder:true,
  },
  {
    id: 'licenseplate',
    numeric: false,
    disablePadding: false,
    label: 'Text_Vehicle_LICENSEPLATE',
    canOrder:true,
  },
  {
    id: 'vehiclestore_person_fullname',
    numeric: false,
    disablePadding: false,
    label: 'Text_Vehicle_DRIVER',
    canOrder:true,
  },
  {
    id: 'tara',
    numeric: false,
    disablePadding: false,
    label: 'Text_Vehicle_TARA',
    canOrder:true,
  },
  {
    id: 'pma',
    numeric: false,
    disablePadding: false,
    label: 'Text_Vehicle_PMA',
    canOrder:true,
  },
  {
    id: 'checkpma',
    numeric: false,
    disablePadding: false,
    label: 'Text_Vehicle_NOTCHECK',
    canOrder:true,
  },
  {
    id: 'enabled',
    numeric: false,
    disablePadding: false,
    label: 'Text_Vehicle_ENABLED',
    canOrder:true,
  }
  
];
 
const VehiclesSettings = ({setShowPrincipalMenu, showVehiclesSettings, setShowVehiclesSettings,setShowModalGeneralSettings}) => {
  
  const {t,i18n} = useTranslation(['listDataGeneralSettings']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const [data, setData] = useState(initialState);
  const [form, setForm] = useState(initialState[0]);
  const filtersVehiclesDetails = useSelector((state) => state.filtersVehicles); 
  const [filtersVehicles, setFiltersVehicles] = useState(initialFilters);
  const [numTotReg, setNumTotReg] = useState(0);
  const [numTotRegFilter, setNumTotRegFilter] = useState(0);
  const [errorsFilters, setErrorsFilters] = useState({});
  const [errors, setErrors] = useState({});
  const [inputText, setInputText] = useState("");
  const [openCreateData, setOpenCreateData] = useState(false);
  const [openDeleteRow, setOpenDeleteRow] = useState(false);
  const [openEditRow, setOpenEditRow] = useState(false);
  const [openEditFilter, setOpenEditFilter] = useState(false);
  const [rowEdit, setRowEdit] = useState(initialState[0]);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingError, setIsLoadingError] = useState(false);
  const [idCodeDelete, setIdCodeDelete] = useState(DELETE_CODE);
  const dispatch = useDispatch();
  const [activeOffset, setActiveOffset] = useState(false);
  const [currencyOffset, setCurrencyOffset] = useState(0);
  const [rangeOffset, setRangeOffset] = useState([{}]); 
  const [tradenameToSelect,setTradenameToSelect]= useState(initialStoresToSelect); 
  const [filteredStoreFrom, setFilteredStoreFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexStoreFrom, setHighlightedIndexStoreFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredStoreTo, setFilteredStoreTo] = useState([]); // Opciones filtradas
  const [highlightedIndexStoreTo, setHighlightedIndexStoreTo] = useState(-1); // Índice de la opción resaltada    
  const [vehiclesToSelect,setVehiclesToSelect]= useState(initialVehicleToSelect); 
  const [filteredVehicleFrom, setFilteredVehicleFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexVehicleFrom, setHighlightedIndexVehicleFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredVehicleTo, setFilteredVehicleTo] = useState([]); // Opciones filtradas
  const [highlightedIndexVehicleTo, setHighlightedIndexVehicleTo] = useState(-1); // Índice de la opción resaltada 
  const [filteredTradename, setFilteredTradename] = useState([]); // Opciones filtradas
  const [highlightedIndexTradename, setHighlightedIndexTradename] = useState(-1); // Índice de la opción resaltada 
  const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
  const [showModalSearchDrivers, setShowModalSearchDrivers] = useState(false); 
  const [documentIdDriverToSelect,setDocumentIdDriverToSelect]= useState(initialDocumentIdToSelect);  
  const [filteredDocumentIdDriver, setFilteredDocumentIdDriver] = useState([]); // Opciones filtradas
  const [highlightedIndexDocumentIdDriver, setHighlightedIndexDocumentIdDriver] = useState(-1); // Índice de la opción resaltada 
  const [tradenameDriverToSelect,setTradenameDriverToSelect]= useState(initialDocumentIdToSelect);  
  const [filteredTradenamedDriver, setFilteredTradenamedDriver] = useState([]); // Opciones filtradas
  const [highlightedIndexTradenamedDriver, setHighlightedIndexTradenamedDriver] = useState(-1); // Índice de la opción resaltada 
  const [openVideoHelpStore, setOpenVideoHelpStore] = useState(false);
  const STORE_VIDEO_URL = "https://dn3b0526k2h3y.cloudfront.net/vehiculos.mp4";
  
  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showVehiclesSettings) {
        setData(initialState);
        setForm(initialState[0]);
        setNumTotReg(0);
        setNumTotRegFilter(0);
        setErrorsFilters({});
        setErrors({});
        setInputText("");
        setOpenCreateData(false);
        setOpenDeleteRow(false);
        setOpenEditRow(false);
        setOpenEditFilter(false);
        setRowEdit(initialState[0]); 
        setIsLoadingError(false);
        setIdCodeDelete(DELETE_CODE);
        setActiveOffset(false);
        setCurrencyOffset(0);
        setRangeOffset([{}]);  
        setShowPrincipalMenu(true);
        setShowVehiclesSettings(false);  
        setTradenameToSelect(initialStoresToSelect);
        setFilteredStoreFrom([]);
        setHighlightedIndexStoreFrom(-1); 
        setFilteredStoreTo([]);  
        setHighlightedIndexStoreTo(-1);  
        setVehiclesToSelect(initialVehicleToSelect);
        setFilteredVehicleFrom([]);
        setHighlightedIndexVehicleFrom(-1);  
        setFilteredVehicleTo([]);
        setHighlightedIndexVehicleTo(-1);  
        setFilteredTradename([]);
        setHighlightedIndexTradename(-1);  
        dispatch(resetPagination());
        dispatch(resetFilters());
        dispatch(setLoading(false));
        setFiltersVehicles(initialState); 
        setShowModalSearchDrivers(false);
        setShowModalSearchStores(false);
        setOpenVideoHelpStore(false); 
        setDocumentIdDriverToSelect(initialDocumentIdToSelect);
        setFilteredDocumentIdDriver([]);
        setHighlightedIndexDocumentIdDriver(0);
        setTradenameDriverToSelect(initialDocumentIdToSelect);
        setFilteredTradenamedDriver([]);
        setHighlightedIndexTradenamedDriver(-1);  
        setShowModalGeneralSettings(false);
      }
    },
    [ setData,
      setForm,
      setFiltersVehicles,
      setNumTotReg,
      setNumTotRegFilter,
      setErrorsFilters,
      setErrors,
      setInputText,
      setOpenCreateData,
      setOpenDeleteRow,
      setOpenEditRow,
      setOpenEditFilter,
      setRowEdit,
      setIsLoadingError,
      setIdCodeDelete,
      setActiveOffset,
      setCurrencyOffset,
      setRangeOffset,   
      showVehiclesSettings, 
      setShowPrincipalMenu,
      setShowVehiclesSettings,
      setShowModalGeneralSettings,
      setOpenVideoHelpStore, 
      setTradenameToSelect,
      setFilteredStoreFrom,
      setHighlightedIndexStoreFrom, 
      setFilteredStoreTo,
      setHighlightedIndexStoreTo, 
      setVehiclesToSelect,
      setFilteredVehicleFrom,
      setHighlightedIndexVehicleFrom, 
      setFilteredVehicleTo,
      setHighlightedIndexVehicleTo, 
      setFilteredTradename,
      setHighlightedIndexTradename,
      setShowModalSearchDrivers,
      setShowModalSearchStores,
      setDocumentIdDriverToSelect,
      setFilteredDocumentIdDriver,
      setHighlightedIndexDocumentIdDriver,
      setTradenameDriverToSelect,
      setFilteredTradenamedDriver,
      setHighlightedIndexTradenamedDriver,
      dispatch,
      DELETE_CODE]
  );

  const closeModalUserTypeSettings = () => {    
    setData(initialState);
      setForm(initialState[0]);
      setNumTotReg(0);
      setNumTotRegFilter(0);
      setErrorsFilters({});
      setErrors({});
      setInputText("");
      setOpenCreateData(false);
      setOpenDeleteRow(false);
      setOpenEditRow(false);
      setOpenEditFilter(false);
      setRowEdit(initialState[0]); 
      setIsLoadingError(false);
      setIdCodeDelete(DELETE_CODE);
      setActiveOffset(false);
      setCurrencyOffset(0);
      setRangeOffset([{}]);  
      setShowPrincipalMenu(true);
      setShowVehiclesSettings(false);  
      setTradenameToSelect(initialStoresToSelect);
      setFilteredStoreFrom([]);
      setHighlightedIndexStoreFrom(-1); 
      setFilteredStoreTo([]);  
      setHighlightedIndexStoreTo(-1); 
      setVehiclesToSelect(initialVehicleToSelect);
      setFilteredVehicleFrom([]);
      setHighlightedIndexVehicleFrom(-1);  
      setFilteredVehicleTo([]);
      setHighlightedIndexVehicleTo(-1);  
      setFilteredTradename([]);
      setHighlightedIndexTradename(-1);  
      dispatch(resetPagination());
      dispatch(resetFilters());
      dispatch(setLoading(false));
      setFiltersVehicles(initialState);
      setShowModalSearchDrivers(false);
      setShowModalSearchStores(false);
      setDocumentIdDriverToSelect(initialDocumentIdToSelect);
      setFilteredDocumentIdDriver([]);
      setHighlightedIndexDocumentIdDriver(0);
      setTradenameDriverToSelect(initialDocumentIdToSelect);
      setFilteredTradenamedDriver([]);
      setHighlightedIndexTradenamedDriver(-1); 
      setOpenVideoHelpStore(false);  
      setShowModalGeneralSettings(false);
  };

  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    }, [callback, delay]);
  };
  // Dentro del componente
  const debouncedHandleSearchStoreFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredStoreFrom([]);
      setHighlightedIndexStoreFrom(-1);
      return;
    }
    const filtered = tradenameToSelect
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredStoreFrom(filtered);
    setHighlightedIndexStoreFrom(0);
  }, 300);
  const handleSelectStoreFrom = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setFiltersVehicles(filtersVehicles => ({
      ...filtersVehicles,
      vehicleStoreFrom: store.tradename || "",
      vehicleStoreTo: store.tradename || filtersVehicles.vehicleStoreTo
    }));
    setFilteredStoreFrom([]);
    setHighlightedIndexStoreFrom(-1);
  }; 
  const handleKeyDownStoreFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredStoreFrom.length === 0 && filtersVehicles.vehicleStoreFrom.trim() === "") {
        setFilteredStoreFrom(tradenameToSelect);
        setHighlightedIndexStoreFrom(0);
      } else {
        setHighlightedIndexStoreFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredStoreFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexStoreFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexStoreFrom >= 0) {
      if (highlightedIndexStoreFrom >= 0 && highlightedIndexStoreFrom < filteredStoreFrom.length) {
        handleSelectStoreFrom(filteredStoreFrom[highlightedIndexStoreFrom]);
      }
    } else if (event.key === "Escape") {
      const isValid = tradenameToSelect.some((store) => {
        if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filtersVehicles.vehicleStoreFrom.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setFiltersVehicles(filtersVehicles => ({
          ...filtersVehicles,
          vehicleStoreFrom: ""
        }));
      }
      setFilteredStoreFrom([]);
      setHighlightedIndexStoreFrom(-1);
    }
  };
  // Dentro del componente
  const debouncedHandleSearchStoreTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredStoreTo([]);
      setHighlightedIndexStoreTo(-1);
      return;
    }
    const filtered = tradenameToSelect
      .filter(store=>(store.tradename>=filtersVehicles.vehicleStoreFrom))
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredStoreTo(filtered);
    setHighlightedIndexStoreTo(0);
  }, 300);
   const handleSelectStoreTo = (store) => {
     if (!store) return; // Validación adicional para evitar errores
     setFiltersVehicles(filtersVehicles => ({
      ...filtersVehicles,
      vehicleStoreTo:  store.tradename || ""
    }));
    setFilteredStoreTo([]);
    setHighlightedIndexStoreTo(-1);
   }; 
   const handleKeyDownStoreTo = (event) => {
     if (event.key === "ArrowDown") {
       if (filteredStoreTo.length === 0 && filtersVehicles.vehicleStoreTo.trim() === "") {
         const filtered = tradenameToSelect.filter(item=>(item.tradename>=filtersVehicles.vehicleStoreFrom));
         setFilteredStoreTo(filtered);
         setHighlightedIndexStoreTo(0);
       } else {
         setHighlightedIndexStoreTo((prevIndex) => {
           const nextIndex = prevIndex < filteredStoreTo.length - 1 ? prevIndex + 1 : prevIndex;
           scrollToElement(nextIndex);
           return nextIndex;
         });
       }
     } else if (event.key === "ArrowUp") {
       setHighlightedIndexStoreTo((prevIndex) => {
         const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
         scrollToElement(prevIndexValid);
         return prevIndexValid;
       });
     } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexStoreTo >= 0) {
       if (highlightedIndexStoreTo >= 0 && highlightedIndexStoreTo < filteredStoreTo.length) {
         handleSelectStoreTo(filteredStoreTo[highlightedIndexStoreTo]);
       }
     } else if (event.key === "Escape") {
       const isValid = tradenameToSelect
       .filter(item=>(item.tradename>=filtersVehicles.vehicleStoreFrom))
       .some((store) => {
        if (!store || !store.tradename) return false; 
          const normalizedTradeName = store.tradename.toUpperCase();
          const normalizedInputTradeName = filtersVehicles.vehicleStoreTo.toUpperCase();
          return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setFiltersVehicles(filtersVehicles => ({
          ...filtersVehicles,
          vehicleStoreTo:  ""
        }));
      }
      setFilteredStoreTo([]);
      setHighlightedIndexStoreTo(-1);
     }
   };  
  // Dentro del componente
  const debouncedHandleSearchVehicleFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredVehicleFrom([]);
      setHighlightedIndexVehicleFrom(-1);
      return;
    }
    const filtered = vehiclesToSelect
      .filter(vehicle => vehicle && vehicle.vehiclestore_licenseplate)
      .filter(vehicle => {
        const vehiclestore_licenseplate = vehicle.vehiclestore_licenseplate.toUpperCase();
         return vehiclestore_licenseplate.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredVehicleFrom(filtered);
      setHighlightedIndexVehicleFrom(0);
  }, 300);
  const handleSelectVehicleFrom = (vehicle) => {
    if (!vehicle) return; // Validación adicional para evitar errores
    setFiltersVehicles(filtersVehicles => ({
      ...filtersVehicles,
      licenseplateFrom: vehicle.vehiclestore_licenseplate || "",
      licenseplateTo: vehicle.vehiclestore_licenseplate || filtersVehicles.licenseplateTo,
    }));
    setFilteredVehicleFrom([]);
    setHighlightedIndexVehicleFrom(-1);
  }; 
  const handleKeyDownVehicleFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredVehicleFrom.length === 0 && filtersVehicles.licenseplateFrom.trim() === "") {
        setFilteredVehicleFrom(vehiclesToSelect);
        setHighlightedIndexVehicleFrom(0);
      } else {
        setHighlightedIndexVehicleFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredVehicleFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexVehicleFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexVehicleFrom >= 0) {
      if (highlightedIndexVehicleFrom >= 0 && highlightedIndexVehicleFrom < filteredVehicleFrom.length) {
        handleSelectVehicleFrom(filteredVehicleFrom[highlightedIndexVehicleFrom]);
      }
    } else if (event.key === "Escape") {
      const isValid = vehiclesToSelect.some((vehicle) => {
        if (!vehicle || !vehicle.vehiclestore_licenseplate) return false; 
        const normalizedVehicle = vehicle.vehiclestore_licenseplate.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputVehicle = filtersVehicles.licenseplateFrom.toUpperCase().replace(/[.-]/g, "");
        return normalizedVehicle === normalizedInputVehicle;
      }); 
      if (!isValid) {
        setFiltersVehicles(filtersVehicles => ({
          ...filtersVehicles,
          licenseplateFrom: ""
        }));
      }
      setFilteredVehicleFrom([]);
      setHighlightedIndexVehicleFrom(-1);
    }
  };
  // Dentro del componente
  const debouncedHandleSearchVehicleTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredVehicleTo([]);
      setHighlightedIndexVehicleTo(-1);
      return;
    }
    const filtered = vehiclesToSelect
      .filter(vehicle=>(vehicle.vehiclestore_licenseplate>=filtersVehicles.licenseplateFrom))
      .filter(vehicle => vehicle && vehicle.vehiclestore_licenseplate)
      .filter(vehicle => {
        const vehiclestore_licenseplate = vehicle.vehiclestore_licenseplate.toUpperCase();
        return vehiclestore_licenseplate.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredVehicleTo(filtered);
      setHighlightedIndexVehicleTo(0);
  }, 300);
  const handleSelectVehicleTo = (vehicle) => {
    if (!vehicle) return; // Validación adicional para evitar errores
    setFiltersVehicles(filtersVehicles => ({
      ...filtersVehicles,
      licenseplateTo: vehicle.vehiclestore_licenseplate || ""
    })); 
    setFilteredVehicleTo([]);
    setHighlightedIndexVehicleTo(-1);
  }; 
  const handleKeyDownVehicleTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredVehicleTo.length === 0 && filtersVehicles.licenseplateTo.trim() === "") {
        const filtered = vehiclesToSelect.filter(item=>(item.vehiclestore_licenseplate>=filtersVehicles.licenseplateFrom));
        setFilteredVehicleTo(filtered);
        setHighlightedIndexVehicleTo(0);
      } else {
        setHighlightedIndexVehicleTo((prevIndex) => {
          const nextIndex = prevIndex < filteredVehicleTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexVehicleTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexVehicleTo >= 0) {
      if (highlightedIndexVehicleTo >= 0 && highlightedIndexVehicleTo < filteredVehicleTo.length) {
        handleSelectVehicleTo(filteredVehicleTo[highlightedIndexVehicleTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = vehiclesToSelect
      .filter(item=>(item.vehiclestore_licenseplate>=filtersVehicles.licenseplateFrom))
      .some((vehicle) => {
        if (!vehicle || !vehicle.vehiclestore_licenseplate) return false; 
        const normalizedVehicle = vehicle.vehiclestore_licenseplate.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputVehicle = filtersVehicles.licenseplateTo.toUpperCase().replace(/[.-]/g, "");
        return normalizedVehicle === normalizedInputVehicle;
      }); 
      if (!isValid) {
        setFiltersVehicles(filtersVehicles => ({
          ...filtersVehicles,
           licenseplateTo: ""
        }));   
      }
      setFilteredVehicleTo([]);
      setHighlightedIndexVehicleTo(-1);
    }
  }; 
  // Dentro del componente
  const debouncedHandleSearchTradename= useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredTradename([]);
      setHighlightedIndexTradename(-1);
      return;
    }
    const filtered = tradenameToSelect
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        return tradename.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredTradename(filtered);
      setHighlightedIndexTradename(0);
  }, 300);
  const handleSelectTradeName = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setForm((form) => ({
      ...form,
      vehiclestore_store_id: store.id || 0,
      vehiclestore_store_tradename: store.tradename || ""
    }));
    setFilteredTradename([]);
    setHighlightedIndexTradename(-1);
  }; 
  const handleKeyDownTradename = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredTradename.length === 0 && form.vehiclestore_store_tradename.trim() === "") {
        setFilteredTradename(tradenameToSelect);
        setHighlightedIndexTradename(0);
      } else {
        setHighlightedIndexTradename((prevIndex) => {
          const nextIndex = prevIndex < filteredTradename.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexTradename((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradename >= 0) {
      if (highlightedIndexTradename >= 0 && highlightedIndexTradename < filteredTradename.length) {
        handleSelectTradeName(filteredTradename[highlightedIndexTradename]);
      }
    } else if (event.key === "Escape") {
      const isValid = tradenameToSelect.some((store) => {
        if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = form.vehiclestore_store_tradename.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setForm((form) => ({
          ...form,
          vehiclestore_store_id: 0,
          vehiclestore_store_tradename: "",
        }));
      } 
      setFilteredTradename([]);
      setHighlightedIndexTradename(-1);
    }
  };

  // Dentro del componente
  const debouncedHandleSearchDocumentIdDriver = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
        setFilteredDocumentIdDriver([]);
        setHighlightedIndexDocumentIdDriver(-1);
        return;
    }
    const filtered = documentIdDriverToSelect
        .filter(driver => driver && driver.documentid)
        .filter(driver => {
        const documentid = driver.documentid.toUpperCase();
        return documentid.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
    setFilteredDocumentIdDriver(filtered);
    setHighlightedIndexDocumentIdDriver(0);
  }, 300);
  const handleSelectDocumentIdDriver = (driver) => {
    if (!driver) {
       setForm((form) => ({
        ...form,
          vehiclestore_person_id: 0,
          vehiclestore_person_numberdocument: "",
          vehiclestore_person_fullname: "",
      }));
      return; // Validación adicional para evitar errores
    }
    setForm((form) => ({
      ...form,
      vehiclestore_person_id:driver.id || 0,
      vehiclestore_person_numberdocument: driver.documentid || "",
      vehiclestore_person_fullname: driver.tradename || "",
    }));
    setFilteredDocumentIdDriver([]);
    setHighlightedIndexDocumentIdDriver(-1);
  }; 
  const handleKeyDownDocumentIdDriver = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredDocumentIdDriver.length === 0 && form.vehiclestore_person_numberdocument.trim() === "") {
        setFilteredDocumentIdDriver(documentIdDriverToSelect);
        setHighlightedIndexDocumentIdDriver(0);
      } else {
        setHighlightedIndexDocumentIdDriver((prevIndex) => {
        const nextIndex = prevIndex < filteredDocumentIdDriver.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexDocumentIdDriver((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentIdDriver >= 0) {
      if (highlightedIndexDocumentIdDriver >= 0 && highlightedIndexDocumentIdDriver < filteredDocumentIdDriver.length) {
        handleSelectDocumentIdDriver(filteredDocumentIdDriver[highlightedIndexDocumentIdDriver]);
      }
    } else if (event.key === "Escape") {
      const isValid = documentIdDriverToSelect.some((driver) => {
      if (!driver || !driver.documentid) return false; 
        const normalizedStoreId = driver.documentid.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputId = form.vehiclestore_person_numberdocument.toUpperCase();
        return normalizedStoreId === normalizedInputId;
      }); 
      if (!isValid) {
        setForm((form) => ({
          ...form,
          vehiclestore_person_id: 0,
          vehiclestore_person_numberdocument:"",
          vehiclestore_person_fullname: "",
        }));
      } 
      setFilteredDocumentIdDriver([]);
      setHighlightedIndexDocumentIdDriver(-1);
    }
  };

  // Dentro del componente
  const debouncedHandleSearchTradenameDriver= useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
        setFilteredTradenamedDriver([]);
        setHighlightedIndexTradenamedDriver(-1);
    return;
    }
    const filtered = tradenameDriverToSelect
    .filter(driver => driver && driver.tradename)
    .filter(driver => {
        const tradename = driver.tradename.toUpperCase();
        return tradename.includes(upperValue);
    })
    .slice(0, 20); // limitar resultados
    setFilteredTradenamedDriver(filtered);
    setHighlightedIndexTradenamedDriver(0);
  }, 300);
  // Manejo de la selección de una tienda
  const handleSelectTradeNameDriver = (driver) => {
     if (!driver) {
       setForm((form) => ({
        ...form,
          vehiclestore_person_id: 0,
          vehiclestore_person_numberdocument: "",
          vehiclestore_person_fullname: "",
      }));
      return; // Validación adicional para evitar errores
    }
    setForm((form) => ({
      ...form,
      vehiclestore_person_id:driver.id || 0,
      vehiclestore_person_numberdocument: driver.documentid || "",
      vehiclestore_person_fullname: driver.tradename || "",
    }));
    setFilteredTradenamedDriver([]);
    setHighlightedIndexTradenamedDriver(-1);
  }; 
  const handleKeyDownTradenameDriver = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredTradenamedDriver.length === 0 && form.vehiclestore_person_fullname.trim() === "") {
        setFilteredTradenamedDriver(tradenameDriverToSelect);
        setHighlightedIndexTradenamedDriver(0);
      } else {
        setHighlightedIndexTradenamedDriver((prevIndex) => {
        const nextIndex = prevIndex < filteredTradenamedDriver.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexTradenamedDriver((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamedDriver >= 0) {
      if (highlightedIndexTradenamedDriver >= 0 && highlightedIndexTradenamedDriver < filteredTradenamedDriver.length) {
        handleSelectTradeNameDriver(filteredTradenamedDriver[highlightedIndexTradenamedDriver]);
      }
    } else if (event.key === "Escape") {
      const isValid = tradenameDriverToSelect.some((driver) => {
        if (!driver || !driver.tradename) return false; 
          const normalizedTradeName = driver.tradename.toUpperCase();
          const normalizedInputTradeName = form.vehiclestore_person_fullname.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setForm((form) => ({
          ...form,
          vehiclestore_person_id: 0,
          vehiclestore_person_numberdocument:"",
          vehiclestore_person_fullname: "",
        }));
      } 
      setFilteredTradenamedDriver([]);
      setHighlightedIndexTradenamedDriver(-1);
    }
  };

   // Función para desplazar el contenedor
  const scrollToElement = (index) => {
    const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
    const item = dropdown?.children[index];
    if (item) {
      item.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };

  const handleBlur = useCallback((event) => {
    if (!event || !event.currentTarget) return;
    // Asegúrate de que no se cierra si haces clic en un elemento de la lista
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setFilteredStoreFrom([]);
      setHighlightedIndexStoreFrom(-1); 
      setFilteredStoreTo([]);
      setHighlightedIndexStoreTo(-1);  
      setFilteredVehicleFrom([]);
      setHighlightedIndexVehicleFrom(-1);
      setFilteredVehicleTo([]);
      setHighlightedIndexVehicleTo(-1);
      setFilteredTradename([]);
      setHighlightedIndexTradename(-1); 
      setFilteredDocumentIdDriver([]);
      setHighlightedIndexDocumentIdDriver(-1); 
      setFilteredTradenamedDriver([]);
      setHighlightedIndexTradenamedDriver(-1);
    }
  }, []);

  const openCreateOrEditData = () => {
    setInputText("");
    setOpenCreateData(true);
  };

  const openEditFilters = () => {
    setOpenEditFilter(!openEditFilter);
  };

  const handleSubmitFilterEdit = () => {
    setErrorsFilters(validateFormFilter()); 
    if (Object.keys(errorsFilters).length === 0) {
      setErrorsFilters({});
      dispatch(resetPagination());
      dispatch(setFilters(filtersVehicles));
      setOpenEditFilter(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  
  const handleDeleteFilters = () => {
    setErrorsFilters({});
    dispatch(resetFilters());
    dispatch(resetPagination());
    setFiltersVehicles(initialFilters); 
    setOpenEditFilter(!openEditFilter);
  };

  const handleCancelFilters = () => {
    setErrorsFilters({});
    setOpenEditFilter(!openEditFilter);
  };
  
  const handleChangeFilterEdit = (e) => {
    const { name, value } = e.target;
    setFiltersVehicles(filtersVehicles => ({
      ...filtersVehicles,
      [name]: value
    }));
  };

  const handleBlurFilterEdit = (e) => {
    setErrorsFilters(validateFormFilter());
    handleChangeFilterEdit(e);
  };

  const handleChangeEnabledFilter = (e) => {
    setFiltersVehicles(filtersVehicles => ({
      ...filtersVehicles,
      enabled: !filtersVehicles.enabled
    }));
  };

  const handleChangeNotEnabledFilter = (e) => {
    setFiltersVehicles(filtersVehicles => ({
      ...filtersVehicles,
      notenabled: !filtersVehicles.notenabled
    }));
  };

  const handleChangeCheckPMAFilter = (e) => {
    setFiltersVehicles(filtersVehicles => ({
      ...filtersVehicles,
      checkpma: !filtersVehicles.checkpma
    }));
  };

  const handleChangeNOTCheckPMAFilter = (e) => {
    setFiltersVehicles(filtersVehicles => ({
      ...filtersVehicles,
      notcheckpma: !filtersVehicles.notcheckpma
    }));
  };

  const toggleDrawerFilterEdit = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      setErrorsFilters({});
      setFiltersVehicles(initialFilters);
      setOpenEditFilter(!openEditFilter);
    }
  };

  const validateFormFilter = () => {
    let errorsFilters = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (filtersVehicles.idFrom!=="" & !regexNumber.test(filtersVehicles.idFrom)) {
      errorsFilters.idFrom = 'Text_TextNoNumber';
    }
    if (filtersVehicles.idTo!=="" & !regexNumber.test(filtersVehicles.idTo)) {
      errorsFilters.idTo = 'Text_TextNoNumber';
    }
    if (filtersVehicles.idFrom!=="" & !errorsFilters.idFrom!==undefined){
      if (filtersVehicles.idTo!=="" & !errorsFilters.idTo!==undefined){
        if (parseInt(filtersVehicles.idTo)<parseInt(filtersVehicles.idFrom)){
          errorsFilters.idTo = 'Text_TextGreater_Id';
        }
      }
    }
    if (filtersVehicles.taraFrom!=="" & !regexNumber.test(filtersVehicles.taraFrom)) {
      errorsFilters.taraFrom = 'Text_TextNoNumber';
    }
    if (filtersVehicles.taraTo!=="" & !regexNumber.test(filtersVehicles.taraTo)) {
      errorsFilters.taraTo = 'Text_TextNoNumber';
    }
    if (filtersVehicles.taraFrom!=="" & !errorsFilters.taraFrom!==undefined){
      if (filtersVehicles.taraTo!=="" & !errorsFilters.taraTo!==undefined){
        if (parseInt(filtersVehicles.taraTo)<parseInt(filtersVehicles.taraFrom)){
          errorsFilters.taraTo = 'Text_TextGreater_Tara';
        }
      }
    }

    if (filtersVehicles.pmaFrom!=="" & !regexNumber.test(filtersVehicles.pmaFrom)) {
      errorsFilters.pmaFrom = 'Text_TextNoNumber';
    }
    if (filtersVehicles.pmaTo!=="" & !regexNumber.test(filtersVehicles.pmaTo)) {
      errorsFilters.pmaTo = 'Text_TextNoNumber';
    }
    if (filtersVehicles.pmaFrom!=="" & !errorsFilters.pmaFrom!==undefined){
      if (filtersVehicles.pmaTo!=="" & !errorsFilters.pmaTo!==undefined){
        if (parseInt(filtersVehicles.pmaTo)<parseInt(filtersVehicles.pmaFrom)){
          errorsFilters.pmaTo = 'Text_TextGreater_Pma';
        }
      }
    }

    if (regexInvalidCharacters.test(filtersVehicles.licenseplateFrom)) {
      errorsFilters.licenseplateFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersVehicles.licenseplateTo)) {
      errorsFilters.licenseplateTo = 'Text_TextNoValid';
    } 

    if (filtersVehicles.licenseplateTo!=="" & filtersVehicles.licenseplateTo<filtersVehicles.licenseplateFrom){
      errorsFilters.licenseplateTo = 'Text_TextGreater_LicensePlate';
    }

    if (regexInvalidCharacters.test(filtersVehicles.defaultdriverFrom)) {
      errorsFilters.defaultdriverFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersVehicles.defaultdriverTo)) {
      errorsFilters.defaultdriverTo = 'Text_TextNoValid';
    } 

    if (filtersVehicles.defaultdriverTo!=="" & filtersVehicles.defaultdriverTo<filtersVehicles.defaultdriverFrom){
      errorsFilters.defaultdriverTo = 'Text_TextGreater_DefaultDriver';
    }
    return errorsFilters;
  }  

  const filteredData = data.filter((el) => {
    if (inputText === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') +
        String(el.licenseplate || '') +
        String(el.vehiclestore_person_fullname || '') +
        String(el.vehiclestore_store_tradename || '');
      let result = dataTranslate.toLowerCase().includes(inputText.toLowerCase());
      return result;
    }
  })

  let inputHandler = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputText(lowerCase);
  };

  const handleChangeDeleteRow = (e) => {
    const value  = e.target.value;
    setIdCodeDelete(value);
  };

  const handleCancelDeleteRow = () => {
    setErrors({});
    setRowEdit(initialState[0]);
    setForm(initialState[0]);
    dispatch(setLoading(false)); 
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRow(false);

  };

  const handleCloseDeleteRow = (e) => {
    if (idCodeDelete !== DELETE_CODE) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    }
    if (e.key !== 'Escape') {
      if (rowEdit.id !== '') {
        const fetchData = async () => {
          dispatch(setLoading(true));
          try {
            const getData = await helpHttp().del(ENDPOINT, `vehicles/deletevehicles`, token, rowEdit);
            if (getData.status === "OK") {
              dispatch(successErrorAction(t('Text_ValidCode')));
              dispatch(successErrorAction(t('Text_DeleteField')));
            } else {
              dispatch(warningErrorAction(t(getData.cause)));
            }
            dispatch(setLoading(false));
          } catch (error) {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }  
        };
        fetchData();
      } else {
        dispatch(warningErrorAction(t('Text_InvalidId')));
      }
    } 
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRow(false);
    handleCloseDataEdit();
  };

  const handleSubmitDataEdit = () => {
    setErrors(validateForm());
    const errorsToCheck = validateForm();
  
    if (Object.keys(errorsToCheck).length === 0 && form.licenseplate !== '' && form.vehiclestore_store_id !==undefined && form.vehiclestore_store_id !== '' && form.vehiclestore_store_id !== '0') {
      const fetchData = async () => {
        dispatch(setLoading(true));
        try {
          const getData = openEditRow
            ? await helpHttp().put(ENDPOINT, `vehicles/updatevehicles`, token, form)
            : await helpHttp().post(ENDPOINT, `vehicles/savevehicles`, token, form);
          if (getData.status === "OK") {
            dispatch(successErrorAction(t('Text_SaveData')));
            dispatch(setLoading(false));
            handleCloseDataEdit();
          } else {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t(getData.cause)));
          }
        } catch (error) { 
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t('Text_IncorrectData')));  
        } 
      };
      fetchData();
    } else {
      if (errorsToCheck.licenseplate) {
        dispatch(warningErrorAction(t(errorsToCheck.licenseplate)));
      }else{
        if (errorsToCheck.vehiclestore_store_id) {
          dispatch(warningErrorAction(t(errorsToCheck.vehiclestore_store_id)));
        } else{
          dispatch(warningErrorAction(t('Text_IncorrectData')));
        }    
        
      }
    }
  };

  const handleCloseDataEdit = () => {
    setOpenCreateData(false);
    setOpenEditRow(false);
    setRowEdit(openEditRow?rowEdit:initialState[0]);
    setForm(initialState[0]);
    setErrors({});
    dispatch(setLoading(false));
    setIsLoadingError(false);
    toggleDrawerDataEdit(false);
	};

  const handleBlurDataEdit = (e) => {
    handleChangeDataEdit(e);
    setErrors(validateForm());
  };
  
  const handleChangeDataEdit = (e) => {
    const { name, value } = e.target;
    setForm(form => ({
      ...form,
      [name]: value
    }));
  };

  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= 10000000) return true;
    return false;
  };

  const handleBlurNumeric = (value, row) => {
    handleChangeNumeric(value, row);
    setErrors(validateForm());
  };

  const handleChangeNumeric = (e) => {
    const { name, value } = e.target;
    let newValue=value!==null?Number((value.toLocaleString()).replaceAll(",","").replaceAll("kg","").replaceAll("€","").replaceAll("%","").replaceAll(" ","")):0;
    setForm(form => ({
      ...form,
      [name]: newValue
    }));
  };

  const handleChangeCheckPmaVehicle = () => {
    setForm(form => ({
      ...form,
      checkpma: !form.checkpma
    }));
  };

  const handleChangeEnabledVehicle = () => {
    setForm(form => ({
      ...form,
      enabled: !form.enabled
    }));
  };

  const searchDRIVER= (event) => { 
    setShowModalSearchDrivers(true);
  };

  const deleteDriver = (event) => {
    setForm(form => ({
      ...form,
      vehiclestore_person_id:0,
      vehiclestore_person_numberdocument:"",
      vehiclestore_person_fullname: ""
    }));
    setErrors(validateForm());
  };

  const deleteStore = (event) => {
    setForm(form => ({
      ...form,
      vehiclestore_store_id:0,
      vehiclestore_store_tradename:""
    }));
    setErrors(validateForm());
  };

  const searchSTORE= (event) => { 
    setShowModalSearchStores(true);
  };

  const toggleDrawerDataEdit = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault()
      handleCloseDataEdit();
    }
  };

   const validateForm = () => {
    let errors = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    if (!form.vehiclestore_store_id || form.vehiclestore_store_id==="" || form.vehiclestore_store_id==="0" || form.vehiclestore_store_id===0) {
      errors.vehiclestore_store_id = 'Text_FieldStoreRequired';
    } 
    if (!form.licenseplate || form.licenseplate==="") {
      errors.licenseplate = 'Text_FieldLicensePlateRequired';
    } else {
      if (regexInvalidCharacters.test(form.licenseplate)) {
        errors.licenseplate = 'Text_TextNoValid';
      } else{
        if (openEditRow){
          if (data.find((key=>(key.licenseplate.toLowerCase()===form.licenseplate.toLowerCase() && key.id!==rowEdit.id)))) {
            errors.licenseplate = 'Text_Vehicle_LicensePlateExist';
          }
        } else {
          if (data.find((key=>key.licenseplate.toLowerCase()===form.licenseplate.toLowerCase()))) {
            errors.licenseplate = 'Text_Vehicle_LicensePlateExist';
          }
        }  
      }   
    }
    return errors;
  };
 
  useEffect(() => {
    setForm(openEditRow?rowEdit:initialState[0]);
  },[rowEdit,openEditRow]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    if (numTotRegFilter > LIMIT_PAGE) {
      setActiveOffset(true);
      const newRangeOffset = [
        {
          value: 0,
          label: " 1 - " + Number(LIMIT_PAGE).toLocaleString('de-DE'),
        }
      ];
      for (let i = Number(LIMIT_PAGE); i < numTotRegFilter; i += Number(LIMIT_PAGE)) {
        newRangeOffset.push({
          value: i,
          label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMIT_PAGE)).toLocaleString('de-DE'),
        });
      }
      setRangeOffset(newRangeOffset);
    } else {
      setCurrencyOffset(0);
      setActiveOffset(false);
      setRangeOffset([{}]);
    }
  }, [numTotRegFilter]);
 
  useEffect(() => {
    let isMounted = true; 
    const fetchDataDocumentIdDriver = async () => {
        try {
        const getData = await helpHttp().get2(ENDPOINT,`vehicles/getlistdocumentiddriver/`,token,
            (form.vehiclestore_person_numberdocument!==undefined && form.vehiclestore_person_numberdocument!==null && form.vehiclestore_person_numberdocument.replace(/[.\-/\\|]/g, "").trim()!=="")?form.vehiclestore_person_numberdocument.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
            setDocumentIdDriverToSelect(getData); 
        }
        } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
    };   
    if (showVehiclesSettings){
      if (form.vehiclestore_person_numberdocument && form.vehiclestore_person_numberdocument.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataDocumentIdDriver();
      }
    } else{
      setDocumentIdDriverToSelect(initialDocumentIdToSelect);
    } 
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,form.vehiclestore_person_numberdocument,showVehiclesSettings]);

  useEffect(() => {
    let isMounted = true; 
    const fetchDataTradenameDriver = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`vehicles/getlisttradenamedriver/`,token,
            (form.vehiclestore_person_fullname!==undefined && form.vehiclestore_person_fullname!==null && form.vehiclestore_person_fullname.replace(/[.\-/\\|]/g, "").trim()!=="")?form.vehiclestore_person_fullname.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
            setTradenameDriverToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    if (showVehiclesSettings){
      if (form.vehiclestore_person_fullname && form.vehiclestore_person_fullname.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataTradenameDriver();
      }
    } else{
      setTradenameDriverToSelect(initialDocumentIdToSelect);
    }  
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,form.vehiclestore_person_fullname,showVehiclesSettings]);
 
  useEffect(() => {
    let isMounted = true; 
    const fetchDataVehicles = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT,`vehicles/getlistvehicles`,token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setVehiclesToSelect(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    const fetchDataTradename = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT,`vehicles/storesorderbyname`,token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) { 
          setTradenameToSelect(getData); 
        }
      } catch (error) { 
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };   

    if (showVehiclesSettings ) {  
      fetchDataTradename(); 
      fetchDataVehicles();
    }
    return () => { isMounted = false };

  }, [t,token,dispatch,roles,filtersVehicles,openEditFilter,showVehiclesSettings]);
 
  useEffect(() => {
    let ignore = false;
  
    const fetchnumTotReg = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get(ENDPOINT, `vehicles/getinformationtablevehicles`, token);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setNumTotReg(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
  
    const fetchnumTotRegFilter = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().post(ENDPOINT, `vehicles/getcountfiltervehicles`, token, filtersVehiclesDetails);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setNumTotRegFilter(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
  
    const fetchData = async () => {
     dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get3(ENDPOINT, `vehicles/getvehicles`, token, currencyOffset, LIMIT_PAGE, filtersVehiclesDetails);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setData(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
  
    if (showVehiclesSettings) {
      fetchnumTotReg();
      fetchnumTotRegFilter();
      fetchData();
      return () => { ignore = true; };
    }
  }, [ t, token, dispatch, openCreateData, openDeleteRow, openEditRow, rowEdit, showVehiclesSettings, filtersVehiclesDetails, currencyOffset]);
  
  return (
    <>
      {showVehiclesSettings && ( 
        <div className="container-fluid formdi-pending-page">
          <div id="myDIV" className="formdi-pending-header">
            <h1 className="formdi-pending-title">
              {isLoadingError?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={openDeleteRow?"warning":"primary"}/>:<i className="fas fa-solid fa-truck text-warning"></i>} {t('Text_Vehicle_Config')}
            </h1> {isLoadingData ?
              <CircularProgress sx={{ color : "#f6c23e"}}/>:
                <>
                <div className="formdi-pending-header-actions"> 
                  {roles[0].listmenus.find((key)=>(key.name==='Handle_Store_Add_Vehicle'))? (
                    <div>
                      <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={openCreateOrEditData} >
                        {t('Button_Create')}
                      </button>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalUserTypeSettings} >
                        {t('Button_Back')}
                      </button>
                    </div>
                  ) : (
                    <div>
                      <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary" onClick={closeModalUserTypeSettings} >
                        {t('Button_Back')}
                      </button>
                    </div>
                  )} 
                  <div
                    className="video-tutorial-cta"
                    onClick={() => setOpenVideoHelpStore(true)}
                    title={t('Text_Video_View')}
                  >
                    <div className="video-tutorial-cta__circle">
                      <i className="fas fa-play"></i>
                    </div> 
                    <div className="video-tutorial-cta__pill">
                      <span className="video-tutorial-cta__tag">{t('Text_Video_Tutorial')}</span>
                      <span className="video-tutorial-cta__title">{t('Button_Video')}</span>
                    </div>
                  </div> 
                </div> 
              </>
            }
          </div>  
          <br/>  
           {/* Buscador */}
          <div className="formdi-pending-search">
            <TextField
              id="outlined-basic"
              variant="outlined"
              value={inputText}
              inputProps={{ style: {fontSize: '18px'} }}
              InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
              placeholder={t('Text_Vehicle_Search')}
              onChange={inputHandler}
              fullWidth
              label={t('Text_Vehicle_Search')}>
            </TextField>
          </div> 
          <br/>
          <div id="myNewDIV" className="formdi-pending-filters">
            <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
            <div className="formdi-pending-filters-row">
              <button type="button" className={`formdi-pending-chip ${filtersVehiclesDetails.vehicleStoreFrom !== "" || filtersVehiclesDetails.vehicleStoreTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ filtersVehiclesDetails.vehicleStoreFrom !== "" || filtersVehiclesDetails.vehicleStoreTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Vehicle_STORE")}
              </button>
              <button type="button" className={`formdi-pending-chip ${filtersVehiclesDetails.licenseplateFrom !== "" || filtersVehiclesDetails.licenseplateTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ filtersVehiclesDetails.licenseplateFrom !== "" || filtersVehiclesDetails.licenseplateTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Vehicle_LICENSEPLATE")}
              </button>  
              <button type="button" className={`formdi-pending-chip ${filtersVehiclesDetails.taraFrom !== "" || filtersVehiclesDetails.taraTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ filtersVehiclesDetails.taraFrom !== "" || filtersVehiclesDetails.taraTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Vehicle_TARA")}
              </button>  
                <button type="button" className={`formdi-pending-chip ${filtersVehiclesDetails.pmaFrom !== "" || filtersVehiclesDetails.pmaTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ filtersVehiclesDetails.pmaFrom !== "" || filtersVehiclesDetails.pmaTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Vehicle_PMA")}
              </button>   
              <button type="button" className={`formdi-pending-chip ${filtersVehiclesDetails.checkpma ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ filtersVehiclesDetails.checkpma? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Vehicle_CHECK")}
              </button> 
              <button type="button" className={`formdi-pending-chip ${filtersVehiclesDetails.notcheckpma ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ filtersVehiclesDetails.notcheckpma? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Vehicle_NOTCHECK")}
              </button> 
              <button type="button" className={`formdi-pending-chip ${filtersVehiclesDetails.enabled ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ filtersVehiclesDetails.enabled? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Vehicle_ENABLED")}
              </button> 
              <button type="button" className={`formdi-pending-chip ${filtersVehiclesDetails.notenabled ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ filtersVehiclesDetails.notenabled? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Vehicle_NOTENABLED")}
              </button>  
            </div>
          </div>
          <br/> 
          {!isLoadingData ?
            <>
              <div className="formdi-pending-card-flat">
                <div className="formdi-pending-card-content">
                  <TableSortingVehicles
                    data={filteredData}
                    headCells={headCells}
                    numTotRegFilter={numTotRegFilter}
                    titleTable={t('Text_Vehicle_Table')}
                    setOpenDeleteRow={setOpenDeleteRow}
                    setOpenEditRow={setOpenEditRow}
                    setRowEdit={setRowEdit}
                    showEditButton={roles[0].listmenus.find((key)=>(key.name==='Handle_Store_Modify_Vehicle'))?true:false}
                    showDeleteButton={roles[0].listmenus.find((key)=>(key.name==='Handle_Store_Delete_Vehicle'))?true:false}
                    numTotReg={numTotReg}
                    activeOffset={activeOffset}
                    rangeOffset={rangeOffset}
                    currencyOffset={currencyOffset}
                    setCurrencyOffset={setCurrencyOffset}  
                  >
                  </TableSortingVehicles>
                </div>             
              </div>
              {openEditFilter &&
                <div>
                  <SwipeableDrawer
                    anchor='right'
                    open={true}
                    onClose={toggleDrawerFilterEdit(false)}
                    onOpen={toggleDrawerFilterEdit(true)}>
                    <Container >
                      <Box sx={{ bgcolor: '#ffffff', width: '850' }}>
                        <br/>
                        <div id="myDIV">
                          <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                        </div>
                        <hr className="sidebar-divider d-none d-md-block"/>
                        <form className="createfiltersvehiclesdelivery" onSubmit={handleCancelFilters}>  
                          <div className="form-floating mb-3 px-4 primary">
                            <div className="form-group">
                              {/* Campo de texto para escribir y filtrar */}
                              <span style={{ position: "relative" }} >
                                <TextField
                                  id="vehicleStoreFrom"
                                  name="vehicleStoreFrom"
                                  value={filtersVehicles.vehicleStoreFrom}
                                  onChange={(e) => {
                                    setFiltersVehicles(prev => ({
                                      ...prev,
                                      vehicleStoreFrom: e.target.value.toUpperCase(),
                                      vehicleStoreTo: e.target.value.toUpperCase()
                                    }));
                                    debouncedHandleSearchStoreFrom(e.target.value);
                                  }}
                                  onKeyDown={handleKeyDownStoreFrom}
                                  onBlur={(event) => {
                                    if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                      handleBlur();
                                    }
                                  }}
                                  label={errorsFilters.vehicleStoreFrom!=null?t(errorsFilters.vehicleStoreFrom):t('Text_Filter_Store_From')}
                                  placeholder={t('Placeholder_Filter_Store_From')}
                                  inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                  variant="outlined" 
                                /> 
                                {/* Desplegable dinámico */}
                                {filteredStoreFrom.length > 0 && (
                                  <div
                                    className="dropdown-class"
                                    style={{
                                      position: "absolute",
                                      left:'0px',
                                      border: "2px solid #4e73df", // Borde azul (#4e73df)
                                      borderRadius: "4px",
                                      marginTop: "4px",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      width: "100%",
                                      fontSize: '18px',
                                      backgroundColor: "#f8f9fa", // Fondo gris claro
                                      zIndex: 1000,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                  >
                                  {filteredStoreFrom.map((store, index) => (
                                      <MenuItem
                                          key={store.id}
                                          onClick={() => handleSelectStoreFrom(store)}
                                          style={{
                                              cursor: "pointer",
                                              padding: "8px",
                                              borderBottom: "1px solid #eee",
                                              fontSize: '18px',
                                              backgroundColor:
                                              index === highlightedIndexStoreFrom ? "#4e73df" : "transparent",
                                              color: index === highlightedIndexStoreFrom ? "white" : "black",
                                          }}
                                      >
                                        {store.tradename} - {store.documentid}
                                      </MenuItem>
                                    ))}
                                  </div>
                                )}
                                </span>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                <span style={{ position: "relative" }} >
                                  <TextField
                                    id="vehicleStoreTo"
                                    name="vehicleStoreTo"
                                    value={filtersVehicles.vehicleStoreTo}
                                    onChange={(e) => {
                                      setFiltersVehicles(prev => ({
                                        ...prev,
                                        vehicleStoreTo: e.target.value.toUpperCase()
                                      }));
                                      debouncedHandleSearchStoreTo(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownStoreTo}
                                    onBlur={(event) => {
                                      if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                        handleBlur();
                                      }
                                    }}
                                    label={errorsFilters.vehicleStoreTo!=null?t(errorsFilters.vehicleStoreTo):t('Text_Filter_Store_To')}
                                    placeholder={t('Placeholder_Filter_Store_To')}
                                    variant="outlined"
                                    inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                  />
                                  {/* Desplegable dinámico */}
                                  {filteredStoreTo.length > 0 && ( 
                                      <div
                                      className="dropdown-class"
                                      style={{
                                        position: "absolute",
                                        left:'0px',
                                        border: "2px solid #4e73df", // Borde azul (#4e73df)
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: '18px',
                                        backgroundColor: "#f8f9fa", // Fondo gris claro
                                        zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                    >
                                      {filteredStoreTo.map((store, index) => (
                                        <MenuItem
                                          key={store.id}
                                            onClick={() => handleSelectStoreTo(store)}
                                            style={{
                                                cursor: "pointer",
                                                padding: "8px",
                                                borderBottom: "1px solid #eee",
                                                fontSize: '18px',
                                                backgroundColor:
                                                index === highlightedIndexStoreTo ? "#4e73df" : "transparent",
                                                color: index === highlightedIndexStoreTo ? "white" : "black",
                                            }}
                                          >
                                            {store.tradename} - {store.documentid}
                                          </MenuItem>
                                      ))}
                                    </div>
                                  )}    
                                </span>
                              </div> 

                              <div className="form-group">
                              {/* Campo de texto para escribir y filtrar */}
                              <span style={{ position: "relative" }}>
                                <TextField
                                  id="licenseplateFrom"
                                  name="licenseplateFrom"
                                  value={filtersVehicles.licenseplateFrom}
                                  onChange={(e) => {
                                    setFiltersVehicles(prev => ({
                                      ...prev,
                                      licenseplateFrom: e.target.value.toUpperCase(),
                                      licenseplateTo: e.target.value.toUpperCase()
                                    }));
                                    debouncedHandleSearchVehicleFrom(e.target.value);
                                  }}
                                  onKeyDown={handleKeyDownVehicleFrom}
                                  onBlur={(event) => {
                                    if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                      handleBlur();
                                    }
                                  }}
                                  label={errorsFilters.licenseplateFrom!=null?t(errorsFilters.licenseplateFrom):t('Text_Filter_LicensePlate_From')}
                                  placeholder={t('Placeholder_Filter_LicensePlate_From')}
                                  inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                  variant="outlined"
                                />
                                {/* Desplegable dinámico */}
                                {filteredVehicleFrom.length > 0 && (
                                  <div
                                    className="dropdown-class"
                                    style={{
                                      position: "absolute",
                                      left:'0px',
                                      border: "2px solid #4e73df", // Borde azul (#4e73df)
                                      borderRadius: "4px",
                                      marginTop: "4px",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      width: "100%",
                                      fontSize: '18px',
                                      backgroundColor: "#f8f9fa", // Fondo gris claro
                                      zIndex: 1000,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                  >
                                    {filteredVehicleFrom.map((vehicle, index) => (
                                      <MenuItem
                                          key={vehicle.id}
                                          onClick={() => handleSelectVehicleFrom(vehicle)}
                                          style={{
                                              cursor: "pointer",
                                              padding: "8px",
                                              borderBottom: "1px solid #eee",
                                              fontSize: '18px',
                                              backgroundColor:
                                              index === highlightedIndexVehicleFrom ? "#4e73df" : "transparent",
                                              color: index === highlightedIndexVehicleFrom ? "white" : "black",
                                          }}
                                      >
                                        {vehicle.vehiclestore_licenseplate}
                                      </MenuItem>
                                    ))}
                                  </div>
                                )}
                                </span>  
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                <span style={{ position: "relative" }}>
                                  <TextField
                                    id="licenseplateTo"
                                    name="licenseplateTo"
                                    value={filtersVehicles.licenseplateTo}
                                    onChange={(e) => {
                                      setFiltersVehicles(prev => ({
                                        ...prev,
                                        licenseplateTo: e.target.value.toUpperCase()
                                      }));
                                      debouncedHandleSearchVehicleTo(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownVehicleTo}
                                    onBlur={(event) => {
                                      if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                        handleBlur();
                                      }
                                    }}
                                    label={errorsFilters.licenseplateTo!=null?t(errorsFilters.licenseplateTo):t('Text_Filter_LicensePlate_To')}
                                    placeholder={t('Placeholder_Filter_LicensePlate_To')}
                                    inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                    variant="outlined"
                                  />   
                                  {/* Desplegable dinámico */}
                                  {filteredVehicleTo.length > 0 && (
                                  <div
                                    className="dropdown-class"
                                    style={{
                                      position: "absolute",
                                      left:'0px',
                                      border: "2px solid #4e73df", // Borde azul (#4e73df)
                                      borderRadius: "4px",
                                      marginTop: "4px",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      width: "100%",
                                      fontSize: '18px',
                                      backgroundColor: "#f8f9fa", // Fondo gris claro
                                      zIndex: 1000,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                  >
                                    {filteredVehicleTo.map((vehicle, index) => (
                                      <MenuItem
                                        key={vehicle.id}
                                          onClick={() => handleSelectVehicleTo(vehicle)}
                                          style={{
                                              cursor: "pointer",
                                              padding: "8px",
                                              borderBottom: "1px solid #eee",
                                              fontSize: '18px',
                                              backgroundColor:
                                              index === highlightedIndexVehicleTo ? "#4e73df" : "transparent",
                                              color: index === highlightedIndexVehicleTo ? "white" : "black",
                                          }}
                                        >
                                          {vehicle.vehiclestore_licenseplate}
                                        </MenuItem>
                                    ))}
                                  </div>
                                )}    
                              </span>  
                            </div> 

                            <div className="form-group">
                              <NumericFormat 
                                thousandSeparator={','} 
                                decimalSeparator={'.'} 
                                decimalScale= {0}
                                fixedDecimalScale= {true}
                                allowNegative= {false}
                                isAllowed={withValueCap}
                                id="taraFrom" 
                                name="taraFrom" 
                                value={filtersVehicles.taraFrom}
                                label={errorsFilters.taraFrom!=null?t(errorsFilters.taraFrom):t('Text_Filter_Tara_From')}
                                placeholder={t('Placeholder_Filter_Tara_From')}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 20 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                customInput={TextField}
                                onBlur={handleBlurFilterEdit}
                                onChange={handleChangeFilterEdit} 
                              /> 
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                              <NumericFormat 
                                thousandSeparator={','} 
                                decimalSeparator={'.'} 
                                decimalScale= {0}
                                fixedDecimalScale= {true}
                                allowNegative= {false}
                                isAllowed={withValueCap}
                                id="taraTo" 
                                name="taraTo" 
                                value={filtersVehicles.taraTo}
                                label={errorsFilters.taraTo!=null?t(errorsFilters.taraTo):t('Text_Filter_Tara_To')}
                                placeholder={t('Placeholder_Filter_Tara_To')}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 20 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                customInput={TextField}
                                onBlur={handleBlurFilterEdit}
                                onChange={handleChangeFilterEdit} 
                              />  
                            </div>

                            <div className="form-group">
                              <NumericFormat 
                                thousandSeparator={''} 
                                decimalSeparator={'.'} 
                                decimalScale= {0}
                                fixedDecimalScale= {true}
                                allowNegative= {false}
                                isAllowed={withValueCap}
                                id="pmaFrom" 
                                name="pmaFrom" 
                                value={filtersVehicles.pmaFrom}
                                label={errorsFilters.pmaFrom!=null?t(errorsFilters.pmaFrom):t('Text_Filter_Pma_From')}
                                placeholder={t('Placeholder_Filter_Pma_From')}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 20 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                customInput={TextField}
                                onBlur={handleBlurFilterEdit}
                                onChange={handleChangeFilterEdit} 
                              /> 
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                              <NumericFormat 
                                thousandSeparator={''} 
                                decimalSeparator={'.'} 
                                decimalScale= {0}
                                fixedDecimalScale= {true}
                                allowNegative= {false}
                                isAllowed={withValueCap}
                                id="pmaTo" 
                                name="pmaTo" 
                                value={filtersVehicles.pmaTo}
                                label={errorsFilters.pmaTo!=null?t(errorsFilters.pmaTo):t('Text_Filter_Pma_To')}
                                placeholder={t('Placeholder_Filter_Pma_To')}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 20 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                customInput={TextField}
                                onBlur={handleBlurFilterEdit}
                                onChange={handleChangeFilterEdit} 
                              />  
                            </div>

                            <div className="form-group">
                              <Checkbox
                                id="checkpma" 
                                name="checkpma" 
                                checked={filtersVehicles.checkpma}
                                onChange={handleChangeCheckPMAFilter}
                                variant="standard"
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                }}
                              />
                              &nbsp;&nbsp;    
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_CHECK')}</label>  
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <Checkbox
                                id="notcheckpma" 
                                name="notcheckpma" 
                                checked={filtersVehicles.notcheckpma}
                                onChange={handleChangeNOTCheckPMAFilter}
                                variant="standard"
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                }}
                              />
                              &nbsp;&nbsp;    
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_NOTCHECK')}</label>    
                            </div>

                            <div className="form-group">
                              <Checkbox
                                id="enabled" 
                                name="enabled" 
                                checked={filtersVehicles.enabled}
                                onChange={handleChangeEnabledFilter}
                                variant="standard"
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                }}
                              />
                              &nbsp;&nbsp;    
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_ENABLED')}</label>  
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <Checkbox
                                id="notenabled" 
                                name="notenabled" 
                                checked={filtersVehicles.notenabled}
                                onChange={handleChangeNotEnabledFilter}
                                variant="standard"
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                }}
                              />
                              &nbsp;&nbsp;    
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_NOTENABLED')}</label>    
                            </div>
                          </div>
                          <hr className="sidebar-divider d-none d-md-block" />
                          <div className="formdi-pending-action-group">
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEdit}>
                              {t('Button_Apply')}
                            </button> 
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFilters}>
                              {t('Button_Cancel_Filters')}
                            </button>
                          </div> 
                        </form>
                      </Box>
                    </Container>
                  </SwipeableDrawer>
                </div>
              }  
              
              {(openCreateData || openEditRow) && 
                <div>
                  <SwipeableDrawer
                    anchor='right'
                    open={true}
                    onClose={toggleDrawerDataEdit(false)}
                    onOpen={toggleDrawerDataEdit(true)}>
                    <Container >
                      <Box sx={{ bgcolor: '#ffffff',width: '500px' }}>
                        <br/>
                        <div id="myDIV">
                          <h1 className="h1NewStyle px-4 mb-2">{openEditRow?t('Text_Vehicle_Edit'):t('Text_Vehicle_Create')}</h1>
                        </div>  
                        <hr className="sidebar-divider d-none d-md-block"/>
                        <form className="createVehicles" onSubmit={handleSubmitDataEdit}>  
                          <div className="form-floating mb-3 px-4 primary">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Code').toUpperCase()} :</label>
                            <div className="form-group">
                              <TextField
                                id="id" 
                                name="id"
                                value={form.id}
                                inputProps={{ style: {width: 250,fontSize: '18px', }, maxLength: 15 }}
                                style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={t('PlaceHolder_Vehicles_Code')}
                                placeholder={t('PlaceHolder_Vehicles_Code')}
                                variant="standard"/>
                            </div>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_licenseplate').toUpperCase()} :</label>
                            <div className="form-group">
                              <TextField
                                id="licenseplate" 
                                name="licenseplate"
                                value={form.licenseplate}
                                inputProps={{ style: {width: 450,fontSize: '18px', }, maxLength: 50 }}
                                style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errors.licenseplate!=null?t(errors.licenseplate):t('PlaceHolder_Vehicle_licenseplate').toUpperCase()}
                                placeholder={t('PlaceHolder_Vehicle_liceseplate')}
                                variant="standard"
                                onBlur={handleBlurDataEdit}
                                onChange={handleChangeDataEdit} 
                              />
                            </div>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_tara').toUpperCase()} :</label>
                            <div className="form-group">
                              <NumericFormat 
                                thousandSeparator={','} 
                                decimalSeparator={'.'} 
                                decimalScale= {2}
                                fixedDecimalScale= {true}
                                allowNegative= {false}
                                isAllowed={withValueCap}
                                id="tara" 
                                name="tara"
                                suffix={" kg"}
                                value={form.tara}
                                className="numeric-field"
                                onBlur={handleBlurNumeric}
                                onChange={handleChangeNumeric}
                              />   
                            </div> 
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_pma').toUpperCase()} :</label>
                            <div className="form-group">
                              <NumericFormat 
                                thousandSeparator={','} 
                                decimalSeparator={'.'} 
                                decimalScale= {2}
                                fixedDecimalScale= {true}
                                allowNegative= {false}
                                isAllowed={withValueCap}
                                id="pma" 
                                name="pma"
                                suffix={" €"}
                                value={form.pma}
                                className="numeric-field"
                                onBlur={handleBlurNumeric}
                                onChange={handleChangeNumeric}
                              /> 
                            </div>
                            <div className="form-group">
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_NOTCHECK').toUpperCase()} :</label>
                              <Checkbox  
                                style={{color:"#4e73df"}} 
                                checked={form.checkpma} 
                                onChange={handleChangeCheckPmaVehicle} 
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                }}
                              />
                            </div>
                            <div className="form-group">
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_enabled').toUpperCase()} :</label>
                              <Checkbox  
                                style={{color:"#4e73df"}} 
                                checked={form.enabled} 
                                onChange={handleChangeEnabledVehicle} 
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                }}
                              />
                            </div>
                            <h6 className="h7NewStyle mb-2">{t('Text_Vehicle_DRIVER').toUpperCase()}&nbsp;:&nbsp;&nbsp; &nbsp;&nbsp;
                              <IconButton  size="small"  className="deletesmall-select-button"  onClick={deleteDriver}>
                                <DeleteIcon style={{fontSize: 28}}/>
                              </IconButton>    
                              &nbsp;&nbsp;
                              <IconButton  size="small"  className="edit-select-button"  onClick={searchDRIVER}>
                                <SearchIcon style={{fontSize: 28}}/>
                              </IconButton>
                            </h6>
                            {/* Divider */}
                            <hr className="sidebar-divider d-none d-md-block"/>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_documentid').toUpperCase()} :</label>
                            <div className="form-group">
                              <div style={{ position: "relative" }}>
                                <TextField
                                  id="vehiclestore_person_numberdocument"
                                  name="vehiclestore_person_numberdocument"
                                  value={form.vehiclestore_person_numberdocument}
                                  onChange={(e) => {
                                    setForm(prev => ({
                                      ...prev,
                                      vehiclestore_person_numberdocument: e.target.value.toUpperCase()
                                      }));
                                      debouncedHandleSearchDocumentIdDriver(e.target.value);
                                  }}
                                  onKeyDown={handleKeyDownDocumentIdDriver}
                                  onBlur={(event) => {
                                      if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                      handleBlur();
                                      }
                                  }}
                                  label={errors.vehiclestore_person_numberdocument!=null && errors.vehiclestore_person_numberdocument!==""?t(errors.vehiclestore_person_numberdocument):t('Text_documentid')}
                                  placeholder={t('Text_documentid')}
                                  variant="standard"
                                  fullWidth
                                  inputProps={{ style: { fontSize: '18px', }, maxLength: 100 }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              />  
                              {/* Desplegable dinámico */}
                              {filteredDocumentIdDriver.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%", 
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                >
                                  {filteredDocumentIdDriver.map((driver, index) => (
                                    <MenuItem
                                      key={driver.id}
                                      onClick={() => handleSelectDocumentIdDriver(driver)}
                                      style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexDocumentIdDriver ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexDocumentIdDriver ? "white" : "black",
                                      }}
                                    >
                                      {driver.documentid} - {driver.tradename}
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                              </div>
                            </div>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_driver').toUpperCase()} :</label>
                            <div className="form-group">
                              <div style={{ position: "relative" }}>
                                <TextField
                                  id="vehiclestore_person_fullname"
                                  name="vehiclestore_person_fullname"
                                  value={form.vehiclestore_person_fullname}
                                  onChange={(e) => {
                                    setForm(prev => ({
                                      ...prev,
                                      vehiclestore_person_fullname: e.target.value.toUpperCase()
                                    }));
                                    debouncedHandleSearchTradenameDriver(e.target.value);
                                  }}
                                  onKeyDown={handleKeyDownTradenameDriver}
                                  onBlur={(event) => {
                                      if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                      handleBlur();
                                      }
                                  }}
                                  label={errors.vehiclestore_person_fullname!=null && errors.vehiclestore_person_fullname!==""?t(errors.vehiclestore_person_fullname):t('PlaceHolder_Vehicle_driver')}
                                  placeholder={t('PlaceHolder_Vehicle_driver')}
                                  variant="standard"
                                  fullWidth
                                  inputProps={{ style: {fontSize: '18px', }, maxLength: 100 }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                />
                                {/* Desplegable dinámico */}
                                {filteredTradenamedDriver.length > 0 && (
                                  <div
                                    className="dropdown-class"
                                    style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%", 
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                  >
                                    {filteredTradenamedDriver.map((driver, index) => (
                                      <MenuItem
                                          key={driver.id}
                                          onClick={() => handleSelectTradeNameDriver(driver)}
                                          style={{
                                              cursor: "pointer",
                                              padding: "8px",
                                              borderBottom: "1px solid #eee",
                                              fontSize: '18px',
                                              backgroundColor:
                                              index === highlightedIndexTradenamedDriver ? "#4e73df" : "transparent",
                                              color: index === highlightedIndexTradenamedDriver ? "white" : "black",
                                          }}
                                      >
                                          {driver.tradename} - {driver.documentid}
                                      </MenuItem>
                                    ))}
                                  </div>
                                )}
                              </div> 
                            </div>                      
                          
                            <h6 className="h7NewStyle mb-2">{t('Text_Vehicle_STORE').toUpperCase()}&nbsp;:&nbsp;&nbsp; &nbsp;&nbsp;
                              <IconButton  size="small"  className="deletesmall-select-button"  onClick={deleteStore}>
                                <DeleteIcon style={{fontSize: 28}}/>
                              </IconButton>    
                              &nbsp;&nbsp;
                              <IconButton  size="small"  className="edit-select-button"  onClick={searchSTORE}>
                                <SearchIcon style={{fontSize: 28}}/>
                              </IconButton> 
                            </h6>
                            {/* Divider */}
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_User_Stores').toUpperCase()} :</label>
                            <div className="form-group"style={{ position: "relative" }} >
                               <TextField
                                id="vehiclestore_store_tradename"
                                name="vehiclestore_store_tradename"
                                value={form.vehiclestore_store_tradename}
                                onChange={(e) => {
                                  setForm(prev => ({
                                    ...prev,
                                    vehiclestore_store_tradename: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchTradename(e.target.value);
                                }}
                                onKeyDown={handleKeyDownTradename}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errors.vehiclestore_store_tradename!=null?t(errors.vehiclestore_store_tradename):t('Text_User_Stores')}
                                placeholder={t('Text_User_Select_Stores')}
                                variant="standard"
                                inputProps={{ style: {width: 450,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              /> 
                              {/* Desplegable dinámico */}
                              {filteredTradename.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                >
                                  {filteredTradename.map((store, index) => (
                                    <MenuItem
                                        key={store.id}
                                        onClick={() => handleSelectTradeName(store)}
                                        style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: '18px',
                                            backgroundColor:
                                            index === highlightedIndexTradename ? "#4e73df" : "transparent",
                                            color: index === highlightedIndexTradename ? "white" : "black",
                                        }}
                                    >
                                      {store.tradename} - {store.documentid}
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>  
                          <hr className="sidebar-divider d-none d-md-block" />
                          <div className="formdi-pending-action-group">
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitDataEdit}>
                              {openEditRow?t('Button_Update'):t('Button_Create')}
                            </button> 
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleCloseDataEdit}>
                              {t('Button_Cancel')}
                            </button>
                          </div> 
                        </form>
                       
                      </Box> 
                    </Container>
                  </SwipeableDrawer> 
                </div>  
              }
              <VehiclesSearchDrivers
                showModalSearchDrivers={showModalSearchDrivers}
                setShowModalSearchDrivers={setShowModalSearchDrivers} 
                setForm={setForm} 
              /> 
              <VehiclesSearchStores
                showModalSearchStores={showModalSearchStores}
                setShowModalSearchStores={setShowModalSearchStores} 
                setForm={setForm} 
              /> 
            </>:
              <LoadingNews/>
          }
          <Dialog
            open={openVideoHelpStore}
            onClose={() => setOpenVideoHelpStore(false)}
            maxWidth="md"
            fullWidth
            PaperProps={{
              style: {
                borderRadius: "20px",
                overflow: "hidden"
              }
            }}
          >
            <DialogTitle
              sx={{
                color: "#4e73df",
                fontWeight: 500,
                fontSize: "1.4rem"
              }}
            >
              {t('Text_Video_Explain_VEHICLE').toUpperCase()}
            </DialogTitle> 
            <DialogContent sx={{ padding: 0, background: "#000" }}>
              <div className="store-video-wrapper">
                <iframe
                  width="100%"
                  height="100%"
                  src={STORE_VIDEO_URL}
                  title={t('Text_Video_Explain')}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </DialogContent>

            <DialogActions sx={{ padding: "12px 20px" }}>
              <Button
                onClick={() => setOpenVideoHelpStore(false)}
                className="my-dialog-button-cancel"
              >
                {t('Button_Close')}
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={openDeleteRow} onClose={handleCancelDeleteRow} PaperProps={{ className: "my-dialog-paper-danger" }} >
            <DialogTitle className="my-dialog-title-danger">
              {t('Text_Delete')} {rowEdit.id}  - {rowEdit.licenseplate}
            </DialogTitle>
              <DialogContent>
                <DialogContentText className="my-dialog-contentText-danger">
                  {t("Text_Line1")}<br />
                  {t("Text_Line2")}
                </DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="idCode"
                    label={t("Text_Label")}
                    type="text"
                    fullWidth
                    variant="standard"
                    className="my-dialog-input-danger"
                    defaultValue={idCodeDelete}
                    onChange={handleChangeDeleteRow}
                  />
                </DialogContent>
              <DialogActions className="my-dialog-actions">
              <Button
                onClick={handleCancelDeleteRow}
                className="my-dialog-button-cancel-danger"
              >
                {t("Button_Cancel")}
              </Button>
              <Button
                variant="contained"
                onClick={handleCloseDeleteRow}
                className="my-dialog-button-delete"
              >
                {t("Button_Delete")}
              </Button>
            </DialogActions>
          </Dialog>   
          {/* End Content Row */}
        </div>
        //* End Page Content *//
      )}
    </>
  )
}

VehiclesSettings.propTypes = {
  setShowPrincipalMenu: PropTypes.func.isRequired,
  showVehiclesSettings: PropTypes.bool.isRequired,
  setShowVehiclesSettings: PropTypes.func.isRequired,
  setShowModalGeneralSettings: PropTypes.func.isRequired 
};

export default VehiclesSettings;